// extracted by mini-css-extract-plugin
export default {"errorMessage":"ValidationLabel_errorMessage__0KV30","asBigText":"ValidationLabel_asBigText__HTAro","centered":"ValidationLabel_centered__ILobw"};